import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import CountUp from 'react-countup'
import { RealEstateDataPageComponentData } from 'types'

const KPI_3 = (props: RealEstateDataPageComponentData) => {
  const { items, backgroundHexa, titleHexa } = props

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    isMounted && (
      <section
        id="kpi"
        className="p-y-config kpi-3"
      >
        <Row
          style={{
            backgroundColor: backgroundHexa || undefined,
          }}
          className="py-5 justify-content-center gap-5"
        >
          {items?.map((item, index) => (
            <Col
              key={index}
              className="d-flex justify-content-center text-center"
              xs={12}
              md={2}
            >
              <div className="kpi-item-container d-flex flex-column align-items-center text-center">
                <div
                  ref={(el) => {
                    if (el && el.parentNode instanceof HTMLElement) {
                      ;(el.parentNode as HTMLElement).style.minWidth = `${el.offsetWidth}px`
                    }
                  }}
                  className="hidden-number"
                >
                  +999.999
                </div>
                <CountUp
                  start={0}
                  separator="."
                  decimals={0}
                  decimal=","
                  duration={5}
                  className={'kpi-countup '}
                  end={parseFloat(item?.value?.replace(/\./g, '') ?? '')}
                  style={titleHexa ? { color: titleHexa } : {}}
                  prefix={item.simbol || ''}
                />
                <h5 style={titleHexa ? { color: titleHexa } : {}}>{item.title}</h5>
              </div>
            </Col>
          ))}
        </Row>
      </section>
    )
  )
}

export default KPI_3
